import React from 'react';
import {Field, Fields, reduxForm, actionTypes} from 'redux-form'
import DAWASelect from "./DAWASelect";
import DAWAAddress from "./DAWAAddress";
import normalizePNumber from "../../normalizers/normalizePNumber";
import UserProfileInput from "./UserProfileInput";
import userValidator from "./UserValidator";
import SubmitButton from '../common/SubmitButton';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import UserProfilePhoneInput from "./UserProfilePhoneInput";
import afterSubmitFail from '../common/form/focusAfterSubmitFail';

let UserProfileForm = props => {
    let {
        handleSubmit,
        actions,
        regions,
        municipalities,
        addresses,
        initialValues,
        intl,
        openChangePasswordModal
    } = props;

    return (
        <form onSubmit={handleSubmit} noValidate={true}>
            <div className="card-block row">
                <div className="col-12">
                    <Field
                        name="name"
                        className="form-control col-12 mt-2 "
                        type="text"
                        component={UserProfileInput}
                        placeholder={intl.formatMessage(messages.name)}
                        label={intl.formatMessage(messages.name)}
                    />

                    <div className="form-group row">
                        <div className="col-sm-12">
                            <button className="btn btn-default"
                                    type="button"
                                    onClick={openChangePasswordModal}>skift kodeord</button>
                        </div>
                    </div>

                    <Field
                        name="workingTitle"
                        className="form-control col-12 mt-2 "
                        type="text"
                        component={UserProfileInput}
                        placeholder={intl.formatMessage(messages.title)}
                        label={intl.formatMessage(messages.title)}
                    />
                    <Field
                        className="form-control col-12 mt-2 "
                        placeholder="(111) 111-11"
                        name="phone"
                        component={UserProfilePhoneInput}
                        type="tel"
                        label={intl.formatMessage(messages.phone)}
                        normalize={normalizePNumber}
                    />
                    <Field
                        className="form-control col-12 mt-2 "
                        placeholder="(111) 111-11"
                        name="mobilePhone"
                        component={UserProfilePhoneInput}
                        type="tel"
                        label={intl.formatMessage(messages.mobile)}
                        normalize={normalizePNumber}
                    />
                    <Field
                        className="form-control col-12 mt-2 "
                        placeholder="(111) 111-11"
                        name="directPhoneNumber"
                        component={UserProfilePhoneInput}
                        type="tel"
                        label={intl.formatMessage(messages.directPhoneNumber)}
                        normalize={normalizePNumber}
                    />
                    <Field
                        name="email"
                        className="form-control col-12 mt-2"
                        type="email"
                        placeholder={intl.formatMessage(messages.email)}
                        label={intl.formatMessage(messages.email)}
                        component={UserProfileInput}
                    />
                    <Field
                        name="linkedIn"
                        className="form-control col-12 mt-2 "
                        type="text"
                        placeholder="LinkedIn"
                        maxLength="70"
                        label="LinkedIn"
                        component={UserProfileInput}
                    />
                    <div className="form-group row">
                        <div className="col-sm-12">
                            <span className="col-form-label"><b>{intl.formatMessage(messages.regions)}</b></span>
                            <Field
                                name="regionId"
                                type="select"
                                onSelect={actions.updateUserRegionId}
                                onClear={actions.clearUserAddressData}
                                component={DAWASelect}
                                options={regions}
                                resourceType="regions"
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-sm-12">
                            <span className="col-form-label"><b>{intl.formatMessage(messages.municipalities)}</b></span>
                            <Field
                                name="municipalityId"
                                type="select"
                                onSelect={actions.updateUserMunicipalityId}
                                onClear={actions.clearUserAddressData}
                                component={DAWASelect}
                                options={municipalities}
                                resurceType="muncipalities"
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-sm-12">
                            <span className="col-form-label"><b>{intl.formatMessage(messages.address)}</b></span>
                            <Field
                                name="addressId"
                                type="select"
                                addresses={addresses}
                                onSelect={actions.updateUserAddressId}
                                onSearch={actions.searchUserAddress}
                                onDetails={actions.getUserAddressDetails}
                                onClear={actions.clearUserAddressData}
                                component={DAWAAddress}
                                regionId={initialValues.regionId}
                                municipalityId={initialValues.municipalityId}
                                resourceType="address"
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-sm-12">
                            <span className="col-form-label"><strong>{intl.formatMessage(messages.city)}</strong></span>
                            <Field
                                name="city"
                                className="form-control col-12 mt-2 "
                                type="text"
                                placeholder="By"
                                component="input"
                                readOnly={true}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-sm-12">
                            <span className="col-form-label"><strong>{intl.formatMessage(messages.postalCode)}</strong></span>
                            <Field
                                className="form-control col-12 mt-2"
                                name="postalCode"
                                placeholder="Postnummer"
                                component="input"
                                readOnly={true}
                            />
                        </div>
                    </div>
                    {/*<label className="custom-control custom-checkbox">
                        <Field
                            name="isAdmin"
                            type="checkbox"
                            component="input"
                            className="custom-control-input"
                        />
                        <span className="custom-control-indicator"> </span>
                        <span className="custom-control-description">Administrator</span>
                    </label>*/}
                    <hr/>
                    <div className="form-group row">
                        <div className="col-sm-12">
                            <SubmitButton isUpdate={true}/>
                        </div>
                    </div>
                </div>
            </div>

        </form>
    )
};

UserProfileForm = reduxForm({
    form: 'userProfileForm',
    validate: userValidator,
    onSubmitFail: afterSubmitFail
})(UserProfileForm);

export default injectIntl(UserProfileForm);


// WEBPACK FOOTER //
// ./web/src/components/users/UserProfileForm.jsx